export default {
  get_all: { method: "get", url: "api/areas" },
  show: { method: "get", url: "api/areas{/id}" },
  store: { method: "post", url: "api/areas" },
  update: { method: "put", url: "api/areas{/id}" },
  delete: { method: "delete", url: "api/areas{/id}" },
  arvore: { method: "get", url: "api/areas/arvore" }
};
